import { configureStore } from '@reduxjs/toolkit';
import { booksApi } from "../features/books/bookAPISlice";
import filterBooks from '../features/books/filterBooks';

export const store = configureStore({
  reducer: {
    [booksApi.reducerPath]: booksApi.reducer,
    filters:filterBooks
  },
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware().concat(booksApi.middleware),

})